<template>
  <VDataTable
    :headers="headers"
    :items="vacancies"
    item-key="title"
    hide-default-footer
    disable-pagination
    :hide-default-header="vacancies.length === 0"
    class="vacancy-table"
  >
    <template v-slot:item="{ item }">
      <VacancyPresetCopyTableRow
        :key="item.id"
        :company="company"
        :vacancy="item"
      />
    </template>
  </VDataTable>
</template>

<script>
import VacancyPresetCopyTableRow from '@/components/Vacancy/VacancyPresetCopyTableRow';

export default {
  name: 'VacancyPresetCopyTable',
  components: { VacancyPresetCopyTableRow },
  props: {
    company: {
      type: Object,
      required: true,
    },
    vacancies: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('vacancy'),
          value: 'title',
          align: 'left',
          sortable: false,
          // width: '40%',
        },
        {
          text: this.$t('candidates'),
          value: 'invites',
          align: 'left',
          sortable: false,
        },
        {
          text: this.$t('interview'),
          value: 'interview',
          align: 'left',
          sortable: false,
        },
        {
          text: this.$t('questions'),
          value: 'questions',
          align: 'left',
          sortable: false,
        },
        {
          text: '',
          value: 'action',
          sortable: false,
          align: 'left',
          // width: 130,
        },
      ],
    };
  },
};
</script>

<i18n locale="en" lang="yaml">
  vacancy: Job
  candidates: Candidates
  interview: Interviews
  questions: Questions
</i18n>

<i18n locale="ru" lang="yaml">
  vacancy: Вакансия
  candidates: Кандидаты
  interview: Интервью
  questions: Вопросы
</i18n>

<style>
.vacancy-table th {
  padding-bottom: 10px !important;
  font-size: 1.1rem !important;
  font-weight: 500 !important;
}
</style>
